import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../../../services/api";
import { Background, Container, Titulo, Hr, Form, InputLabel, Inputs, ButtonAdd, BigButton, H4, BoxDados } from "./style";
import "./styles.css";
import Auth from "../../../services/auth";
import { Swal, Toast } from "../../../services/SwalTemplates";
import GoBack from "../../../components/GoBack";
import { IoTrashOutline } from "react-icons/io5";

export default function LancamentoProjetosForm() {
  const [id] = useState(Auth.id());
  const [projetos, setProjetos] = useState([]);
  const [projeto, setProjeto] = useState("");
  const [idProjeto, setIdProjeto] = useState(0);
  const [matricula_colaborador, setMatricula_colaborador] = useState(0);
  const [data_inicio, setData_inicio] = useState("");
  const [data_fim, setData_fim] = useState("");
  const [horario_inicio, setHorario_inicio] = useState("");
  const [horario_fim, setHorario_fim] = useState("");
  const [dia_semana, setDia_semana] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [colaborador, setColaborador] = useState("");
  const [rowTable, setRowTable] = useState([]);
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [unidades, setUnidades] = useState([]);
  const [id_unidade, setId_unidade] = useState(0);
  const [nome_unidade, setNome_unidade] = useState("");
  const [descricao, setDescricao] = useState(null);

  useEffect(() => {
    api
      .get(`/coord/projects`)
      .then((response) => {
        setProjetos(response.data.projetos);
      })
      .catch((error) => {
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar os projetos!",
          icon: "error",
        });
      });
    api
      .get(`/coord/contributors?inativo=${false}`)
      .then((response) => {
        setColaboradores(response.data.colaboradores);
      })
      .catch((error) => {
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar os colaboradores!",
          icon: "error",
        });
      });
    api
      .get("/coord/units")
      .then((response) => {
        setUnidades(response.data.unidades);
      })
      .catch((error) => {
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar as unidades!",
          icon: "error",
        });
      });
  }, [id]);

  function calcularCargaHoraria(inicio, fim) {
    const [horaInicio, minutoInicio] = inicio.split(":").map(Number);
    const [horaFim, minutoFim] = fim.split(":").map(Number);

    const totalMinutosInicio = horaInicio * 60 + minutoInicio;
    const totalMinutosFim = horaFim * 60 + minutoFim;

    const diferencaMinutos = totalMinutosFim - totalMinutosInicio;
    const cargaHoraria = diferencaMinutos / 60;

    return cargaHoraria.toFixed(2);
  }

  function addRowTable() {
    const carga = calcularCargaHoraria(horario_inicio, horario_fim);

    setRowTable([
      ...rowTable,
      {
        colaborador: colaborador,
        matricula_colaborador: matricula_colaborador,
        dia_semana: dia_semana,
        horario_inicio: horario_inicio,
        horario_fim: horario_fim,
        carga_horaria: parseFloat(carga),
      },
    ]);
  }

  function sendObj() {
    if (!colaborador || !dia_semana || !horario_inicio || !horario_fim || !id_unidade) {
      return Swal.fire("Atenção!", "Preencha todos os campos obrigatórios!", "warning");
    }
    if (horario_fim <= horario_inicio) {
      return Swal.fire("Atenção!", "Horário final deve ser superior ao horário de início!", "warning");
    }

    const conflito = rowTable.find((r) => {
      if (r.dia_semana === dia_semana && r.matricula_colaborador === matricula_colaborador) {
        return (
          (horario_inicio >= r.horario_inicio && horario_inicio < r.horario_fim) ||
          (horario_fim > r.horario_inicio && horario_fim <= r.horario_fim) ||
          (horario_inicio <= r.horario_inicio && horario_fim >= r.horario_fim)
        );
      }
      return false;
    });

    if (conflito) {
      return Swal.fire(
        "Atenção!",
        `O colaborador já possui horário alocado neste período (${conflito.horario_inicio} - ${conflito.horario_fim})`,
        "warning"
      );
    }

    addRowTable();

    setDia_semana("");
    setHorario_inicio("");
    setHorario_fim("");
  }

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile?.type === "application/pdf") {
      setFile(selectedFile);
      setFileUrl(URL.createObjectURL(selectedFile));
    } else if (selectedFile) {
      Swal.fire("Erro", "Por favor, selecione um arquivo PDF.", "error");
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile?.type === "application/pdf") {
      setFile(droppedFile);
      setFileUrl(URL.createObjectURL(droppedFile));
    } else if (droppedFile) {
      Swal.fire("Erro", "Por favor, arraste um arquivo PDF.", "error");
    }
    setDragActive(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  async function handleSubmit(e) {
    e.preventDefault();

    if (!idProjeto) {
      return Swal.fire("Atenção!", "Selecione uma atividade!", "warning");
    }
    if (!matricula_colaborador) {
      return Swal.fire("Atenção!", "Selecione um colaborador!", "warning");
    }
    if (!data_inicio || !data_fim) {
      return Swal.fire("Atenção!", "Preencha as datas de início e fim!", "warning");
    }
    if (rowTable.length === 0) {
      return Swal.fire("Atenção!", "Adicione ao menos um lançamento à lista!", "warning");
    }

    const formData = new FormData();

    const data = {
      id_projeto: idProjeto,
      matricula_colaborador: matricula_colaborador,
      id_usuario_inseriu: id,
      data_inicio: data_inicio,
      data_fim: data_fim,
      id_unidade: id_unidade,
      nome_unidade: nome_unidade,
      descricao: descricao,
      dados: rowTable,
    };

    formData.append("data", JSON.stringify(data));

    if (file) {
      formData.append("file", file);
    }

    try {
      const response = await api.post(`/coord/projetoslancamentos`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.error) {
        return Swal.fire("Atenção!", response.data.error, "warning");
      }

      Toast.fire({
        icon: "success",
        title: "Cadastrado com sucesso!",
      });

      setTimeout(() => {
        window.location.href = "/projetoslancamentos";
      }, 1000);
    } catch (error) {
      console.error("Erro ao cadastrar:", error);
      Swal.fire("Atenção!", "Erro ao realizar o cadastro!", "error");
    }
  }

  const temLancamentos = rowTable?.length;
  // console.log("unidades", unidades)
  // console.log("colaboradores", colaboradores)
  // console.log("descricao", descricao)

  return (
    <Background>
      <GoBack />
      <Container>
        <Titulo>Lançamentos de Atividades</Titulo>
        <Hr />
        <Form>
          <form onSubmit={handleSubmit}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <InputLabel disabled={temLancamentos}>
                <label
                  style={{
                    marginTop: "15px",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  Atividade
                </label>
                <select
                  disabled={temLancamentos}
                  value={projeto}
                  onChange={(e) => {
                    setProjeto(e.target.value);
                    setIdProjeto(e.target[e.target.options.selectedIndex].id);
                  }}
                  title={temLancamentos ? "Só é possível lançar um tipo de atividade por vez" : ""}
                  style={{ width: "700px", cursor: temLancamentos ? "not-allowed" : "" }}
                  required
                >
                  <option disabled value="">
                    Selecione a atividade
                  </option>
                  {projetos.map((p, i) => (
                    <option key={i} id={p.id}>
                      {p.nome}
                    </option>
                  ))}
                </select>
              </InputLabel>

              <InputLabel disabled={temLancamentos}>
                <label
                  style={{
                    marginTop: "15px",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  Colaborador Principal
                </label>
                <select
                  disabled={temLancamentos}
                  value={colaborador}
                  onChange={(e) => {
                    setColaborador(e.target.value);
                    setMatricula_colaborador(e.target[e.target.options.selectedIndex].id);
                  }}
                  title={temLancamentos ? "Só é possível lançar atividade para um colaborador por vez" : ""}
                  style={{ width: "700px", cursor: temLancamentos ? "not-allowed" : "" }}
                  required
                >
                  <option disabled value="">
                    Selecione o colaborador
                  </option>
                  {colaboradores.map((c, i) => (
                    <option key={i} id={c.matricula} title={c.matricula}>
                      {c.nome} - Mat: {c.matricula}
                    </option>
                  ))}
                </select>
              </InputLabel>
              <InputLabel disabled={temLancamentos}>
                <label
                  style={{
                    marginTop: "15px",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  Unidade
                </label>
                <select
                  disabled={temLancamentos}
                  value={nome_unidade}
                  onChange={(e) => {
                    setId_unidade(e.target[e.target.options.selectedIndex].id);
                    setNome_unidade(e.target.value);
                  }}
                  title={temLancamentos ? "Só é possível lançar atividades para uma unidade por vez" : ""}
                  style={{ width: "700px", cursor: temLancamentos ? "not-allowed" : "" }}
                  required
                >
                  <option disabled value="">
                    Selecione a unidade
                  </option>
                  {unidades.map((c, i) => (
                    <option key={c.id} id={c.id} title={c.nome}>
                      {c.nome}
                    </option>
                  ))}
                </select>
              </InputLabel>
              <InputLabel>
                <label
                  style={{
                    marginTop: "15px",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  Descrição da Atividade (Opcional)
                </label>
                <textarea
                  onChange={(e) => setDescricao(e.target.value)}
                  style={{
                    width: "500px",
                    height: "70px",
                    textAlign: "left",
                    resize: "none",
                    padding: "8px",
                    borderRadius: "5px",
                  }}
                />
              </InputLabel>

              <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
                <InputLabel>
                  <label>Data Início</label>
                  <input
                    type="date"
                    value={data_inicio}
                    onChange={(e) => setData_inicio(e.target.value)}
                    required
                    style={{ width: "340px" }}
                  />
                </InputLabel>

                <InputLabel>
                  <label>Data Fim</label>
                  <input
                    type="date"
                    value={data_fim}
                    onChange={(e) => setData_fim(e.target.value)}
                    required
                    style={{ width: "340px", cursor: !data_inicio ? "not-allowed" : "" }}
                    disabled={!data_inicio}
                    min={data_inicio}
                    title={!data_inicio ? "Selecione a data de início primeiro" : ""}
                  />
                </InputLabel>
              </div>

              {/* Sistema de Upload PDF - Similar ao de Documentos */}
              <InputLabel>
                <label
                  style={{
                    marginTop: "15px",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  Anexo PDF (opcional)
                </label>

                {fileUrl && (
                  <iframe
                    src={fileUrl}
                    title="Preview PDF"
                    style={{
                      width: "700px",
                      height: "400px",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      marginBottom: "10px",
                    }}
                  />
                )}

                <div
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                  style={{
                    width: "700px",
                    minHeight: "120px",
                    border: dragActive ? "2px dashed #007bff" : "2px dashed #ccc",
                    borderRadius: "8px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "20px",
                    backgroundColor: dragActive ? "#f0f8ff" : "#fafafa",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    position: "relative",
                  }}
                  onClick={() => document.getElementById("pdf-input").click()}
                >
                  <input id="pdf-input" type="file" accept=".pdf" onChange={handleFileChange} style={{ display: "none" }} />

                  {file ? (
                    <div style={{ textAlign: "center", width: "100%" }}>
                      <div style={{ fontSize: "16px", fontWeight: "600", marginBottom: "8px", color: "#333" }}>{file.name}</div>
                      <div style={{ fontSize: "14px", color: "#666", marginBottom: "12px" }}>
                        Tamanho: {(file.size / 1024 / 1024).toFixed(2)} MB
                      </div>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setFile(null);
                          setFileUrl(null);
                        }}
                        style={{
                          padding: "8px 20px",
                          backgroundColor: "#dc3545",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        Remover
                      </button>
                    </div>
                  ) : (
                    <div style={{ textAlign: "center", color: "#666" }}>
                      {dragActive ? "Solte o PDF aqui" : "Arraste ou clique para enviar um PDF"}
                    </div>
                  )}
                </div>
              </InputLabel>
            </div>
            <br />

            {rowTable.length > 0 ? (
              <>
                <H4>Horários Adicionados</H4>
                <table style={{ marginTop: 20 }}>
                  <thead>
                    <tr>
                      <th style={{ padding: "5px" }}>Dia</th>
                      <th>Início</th>
                      <th>Fim</th>
                      <th>Carga (h)</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {rowTable.map((r, i) => (
                      <tr key={i}>
                        <td>{r.dia_semana}</td>
                        <td>{r.horario_inicio}</td>
                        <td>{r.horario_fim}</td>
                        <td>{r.carga_horaria}</td>
                        <td>
                          <IoTrashOutline
                            title="Excluir"
                            style={{ fontSize: "25px", cursor: "pointer" }}
                            onClick={() => {
                              setRowTable(rowTable.filter((row, index) => i !== index));
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div style={{ marginTop: "10px", fontWeight: "bold" }}>
                  Carga Total: {rowTable.reduce((acc, r) => acc + r.carga_horaria, 0).toFixed(2)}h
                </div>
              </>
            ) : (
              <></>
            )}

            <Hr />
            <H4>Adicionar Horários de Trabalho</H4>
            <Inputs>
              <InputLabel>
                <label>Dia da Semana</label>
                <select
                  value={dia_semana}
                  onChange={(e) => {
                    setDia_semana(e.target.value);
                  }}
                  id="dia_semana"
                >
                  <option disabled value="">
                    Selecione
                  </option>
                  <option>SEG</option>
                  <option>TER</option>
                  <option>QUA</option>
                  <option>QUI</option>
                  <option>SEX</option>
                  <option>SÁB</option>
                  <option>DOM</option>
                </select>
              </InputLabel>
              <InputLabel>
                <label>Horário Início</label>
                <input
                  type="time"
                  value={horario_inicio}
                  onChange={(e) => {
                    setHorario_inicio(e.target.value);
                  }}
                />
              </InputLabel>
              <InputLabel>
                <label>Horário Fim</label>
                <input
                  type="time"
                  value={horario_fim}
                  onChange={(e) => {
                    setHorario_fim(e.target.value);
                  }}
                />
              </InputLabel>
              <ButtonAdd type="button" onClick={() => sendObj()}>
                +
              </ButtonAdd>
            </Inputs>
            <BigButton type="submit">Salvar</BigButton>
            <Link to="/projetoslancamentos" className="link">
              <BigButton style={{ background: "#e8343d" }}>Cancelar</BigButton>
            </Link>
          </form>
        </Form>
      </Container>
    </Background>
  );
}
